export enum ApiPath {
    Login = `/api/auth/login`,
    Verify = `/api/auth/verify`,
    AutoLogin = `/api/auth/autoLogin`,
    SignUp = `/api/auth/signup`,
    TestPublic = `/api/test/public`,
    TestPrivate = `/api/test/private`,
    EntriesGet = `/api/entries/get`,
    EntriesExport = `/api/entries/export`,
    EntriesSet = `/api/entries/set`,
};